import { Injectable } from '@nestjs/common';
import { SoaksDTO } from './soaks.dto';
import { SoakStyleEntity } from '../soaks.entity';


@Injectable()
export class SoaksAdapter {
    
    public convertDtoToEntity(soaksDTO: SoaksDTO,  isUpdate: boolean = false) : SoakStyleEntity {
        const Soaks = new SoakStyleEntity();
        Soaks.soakstyleId=soaksDTO.soakstyleId,
        Soaks.soakstyle=soaksDTO.soakstyle,
       
        Soaks.isActive=soaksDTO.isActive==undefined?true:soaksDTO.isActive;
        if (isUpdate) {
          Soaks.updatedUser = soaksDTO.updatedUser;
        } else {
          Soaks.isActive = true;
          Soaks.createdUser =soaksDTO.createdUser;
        }
       return Soaks;
      }
      public convertEntityToDto(soaksObject: SoakStyleEntity): SoaksDTO {
        const soaksDTO= new SoaksDTO;
        soaksDTO.soakstyleId=soaksObject.soakstyleId;
        soaksDTO.soakstyle=soaksObject.soakstyle;
      
        soaksDTO.isActive=soaksObject.isActive;
        soaksDTO.createdAt=soaksObject.createdAt;
        soaksDTO.updatedAt=soaksObject.updatedAt;
        soaksDTO.createdUser=soaksObject.createdUser;
        soaksDTO.updatedUser=soaksObject.updatedUser;
        soaksDTO.versionFlag=soaksObject.versionFlag;
        return soaksDTO;
      }
    }
